import configure from './configureStore'

const checkSpecificRole = role => {
    return configure('auth').data.user.roles.includes(role)
}

export default checkSpecificRole